import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'

import styles from 'assets/jss/material-kit-react/views/landingPage.js'
import { getAccountBalanceEth, getETHRate, isSafeToMint } from 'eth/ethUtils'

import ModalDialog from '../ModalDialog'
import { ArrowBackTwoTone } from '@material-ui/icons'
import { tokenDisclaimer } from 'eth/tokenUtils'
import { isNarrow } from 'util/screenUtils'

import { setMintStage } from 'redux/actions/nftActions'
import ErrorLine from 'components/ErrorLine'
import TimerProgress from 'components/mint/TimerProgress'
import { getDisplayError } from 'eth/tokenUtils'
import { decodeHarmonizeError } from 'eth/ethUtils'
import RoyaltyAndPrivileged from './RoyaltyAndPrivileged'
import { getHarmonizeContract } from 'eth/ethUtils'
import { getOptionsMintFee } from 'eth/tokenUtils'
import CheckForWallet from 'components/nft/CheckForWallet'
import { getStorageAsset } from 'redux/actions/assetActions'
import { getStorageSettings } from 'redux/actions/settingsActions'
import { getOptionsFee } from 'eth/tokenUtils'

import { getGasEstimateToMint } from 'eth/ethUtils'
import { MINT_STAGES } from 'redux/reducers/nftReducer'
import TransactionCost from 'components/nft/TransactionCost'
import { getMediaHash } from 'controllers/CoreServiceController'
import { getMediaVideo } from 'util/imageUtils'
import { displayError } from 'util/screenUtils'
import { setNFTMediaHash } from 'redux/actions/nftActions'
import { addNFT,getNFTForMessage} from 'controllers/NFTController'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { getMediaAudio } from 'util/imageUtils'
import { getGweiFromEth } from 'eth/ethUtils'

const useStyles = makeStyles(styles)

export default function MintNFTStart() {
  const narrow = isNarrow(useMediaQuery)
  const [mintFee, setMintFee] = useState()
  const [transactionFee, setTransactionFee] = useState()
  const [gasEstimate, setGasEstimate] = useState()
  const [ethBalance, setEthBalance] = useState()
  const { tokenId, description, messageId, nftMessage, name, price } = useSelector(state => state.nfts)
  const asset = getStorageAsset()
  const {
    currentAsset
  } = asset

  const { currency } = getStorageSettings()
  const [ethInCurrency, setEthInCurrency] = useState(0)

  const [confirmCreation, setConfirmCreation] = useState(false)
  const [error, setError] = useState('')
  const dispatch = useDispatch()

  const classes = useStyles()

  const displayMintError = async (error) => {
    getDisplayError(error, setError, mintFee)
  }

  const displayMint = () => {
    if (!error) {
      if (gasEstimate) {
        console.log('render displayMint')
        return (
          <div
            style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',

              paddingBottom: 5,
              width: narrow ? '100%' : '75%',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <h4 style={{ fontWeight: 'bold', textAlign: 'ceEdnter' }}>
              {isSafeToMint(gasEstimate, ethBalance) ? (
                <Button
                  disabled={!isSafeToMint(gasEstimate, ethBalance)}
                  variant='contained'
                  color='primary'
                  className={classes.submit}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'flex',
                  }}
                  onClick={() => setConfirmCreation(true)}
                >
                  Start Minting
                </Button>
              ) : (
                'You do not have enough Ethereum to mint an NFT'
              )}
            </h4>

            <TransactionCost
              gasEstimate={gasEstimate}
              action='mint'
              ethInCurrency={ethInCurrency}
              ethBalance={ethBalance}
              count={1}
              mintFeeEth={mintFee / 10 ** 18}
            />

          </div>
        )
      } else {
        return (
          <div
            style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              display: 'flex',
              paddingBottom: 5,
              width: narrow ? '100%' : '75%',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <TimerProgress label='Getting estimate...' />
          </div>
        )
      }
    }
  }

  const displayHeader = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          width: '100%',
        }}
      >
        <h3 style={{ lineHeight: 1 }}>

          <ArrowBackTwoTone
            size='small'
            color='primary'
            style={{
              marginRight: '1em',
              height: '100%',
              verticalAlign: 'middle',
            }}
            onClick={() => {
              dispatch(setMintStage(MINT_STAGES.ROYALTY))
              //dispatch(setMintStage(MINT_STAGES.PRIVILEGED))
            }}
          />
          Minting {name}
        </h3>
        <RoyaltyAndPrivileged />
      </div>
    )
  }
  const displayBody = () => {
    return (
      <div>
        {displayHeader()}
        {displayMint()}
      </div>
    )
  }
  const displayRegular = () => {
    return (
      <>
        <div style={{ paddingLeft: '1em', paddingRight: '1em' }}>
          <ErrorLine error={error} />
          {displayBody()}
          <ModalDialog
            title='Confirm Minting'
            message={tokenDisclaimer('mint')}
            close={() => setConfirmCreation(false)}
            open={confirmCreation}
            noLabel='No'
            no={() => setConfirmCreation(false)}
            yesLabel='Yes'
            yes={() => {
              setConfirmCreation(false)
              dispatch(setMintStage(MINT_STAGES.PROGRESS))
            }}
          />
        </div>
      </>
    )
  }

  /**
   * Get the account ETH balance, get the current ETH rate for the currency, then get
   * the gas estimate for minting the token.

   * @param {*} mintFee 
   * @param {*} transactionFee 
   */
  const getEthBalance = async (mintFee, transactionFee) => {
    try {
      const balance = await getAccountBalanceEth()
      setEthBalance(balance)
      getETHRate(currency).then(async (rate) => {
        setEthInCurrency(rate)

        await getGasEstimate(mintFee, transactionFee)
      })
    } catch (error) {
      console.error('getEthBalance failed', error)
      setError(JSON.stringify(error))
    }
  }


  /** Get the gas estimate for the token contract from the server. The cost to mint is
   * affected by the number of CIDs stored, which is the same as the number of assets in the album.
   *
   * For a True Place it is possible to mint an album token with 0 assets, since only the
   * information for the Album and Place is required. In that case the gas estimate is created
   * using the currentAlbum instance.
   * 
   * 
   * @param {*} actualMintFee 
   * @param {*} transactionFee 
   */
  const getGasEstimate = async (actualMintFee, transactionFee) => {
    try {
      console.log(`getGasEstimate mintFee ${actualMintFee} transactionFee ${transactionFee} `)
      const totalFee = actualMintFee
      let estimate = 0
      const priceInGwei=getGweiFromEth(price)
      estimate = await getGasEstimateToMint(tokenId, priceInGwei, totalFee)
      setGasEstimate(estimate)
    } catch (error) {
      console.error('FAILED getting gas estimate', error)
      displayMintError(decodeHarmonizeError(error))
    }
  }
  const getMintFee = () => {
    const tru = getHarmonizeContract()

    tru.methods
      .options()
      .call()
      .then((opts) => {
        console.log(`getMintFee options ${opts}`)
        const fee = getOptionsMintFee(opts)
        const transactionFee = getOptionsFee(opts, 0)
        setMintFee(fee)
        setTransactionFee(transactionFee)
        getEthBalance(fee, transactionFee)
      })
  }
  useEffect(() => {
    const fetchMediaHash = async () => {
      let nft, ok = true
      try {
        nft = await getNFTForMessage(messageId)
      } catch (error) {
        console.log(`getnft error`, error)
        if (error.status !== 404) {
          ok = false
          displayError(error, setError)
        }
      }
      if (ok && !nft) {
        const { category,name:title } = nftMessage
        let mediaElement
        if (CATEGORY_MODES.MUSIC.categories.includes(category)) {
          mediaElement = getMediaAudio(nftMessage.media)
        } else {
          mediaElement = getMediaVideo(nftMessage.media)
        }
        console.log('MintNFTStart useEffect media', mediaElement)
        const { source, name } = mediaElement
        try {
          const hashResponse = await getMediaHash(source, name)
          const { hash } = hashResponse
          dispatch(setNFTMediaHash(hash))
          const priceInGwei=getGweiFromEth(price)
          const nft = await addNFT(tokenId, hash, title, description, messageId, priceInGwei)
          console.log('...received NFT', nft)
        } catch (error) {
          displayError(error, setError)
        }
      }
    }
    fetchMediaHash()
    getMintFee()

  }, [])

  return (
    <CheckForWallet
      render={() => {
        return displayRegular()
      }}
    />
  )
}
